import trinket1 from './blank.png';
import trinket2 from './1.png';
import trinket3 from './2.png';
import trinket4 from './3.png';
import trinket5 from './4.png';
import trinket6 from './5.png';

let trinket = [
    {'url':trinket1, 'num': 0},
    {'url':trinket2, 'num': 1},
    {'url':trinket3, 'num': 2},
    {'url':trinket4, 'num': 3},
    {'url':trinket5, 'num': 4},
    {'url':trinket6, 'num': 5},
];
export default trinket;



// WEBPACK FOOTER //
// ./src/img/trolls-girl/trinket/trinket.js